import { Mail, Phone } from "lucide-react";

export default function MobileCallBar() {
  return (
    <div
      data-testid="mobile-call-bar"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-ink/90 backdrop-blur-xl md:hidden"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href="tel:+14026391139"
          data-testid="mobile-call-button"
          className="flex items-center justify-center gap-2 rounded-full bg-cobalt py-3 text-sm font-bold"
        >
          <Phone className="h-4 w-4" />
          Call 402-639-1139
        </a>
        <a
          href="mailto:Zakilogistics.ne@gmail.com"
          data-testid="mobile-email-button"
          className="flex items-center justify-center gap-2 rounded-full border border-white/20 py-3 text-sm font-semibold"
        >
          <Mail className="h-4 w-4" />
          Email us
        </a>
      </div>
    </div>
  );
}
